module.exports = __webpack_public_path__ + "static/media/b2.b33b291f.png";